module.exports = __webpack_public_path__ + "static/media/pending.97e88e4f.svg";